import { render, staticRenderFns } from "./preloader.vue?vue&type=template&id=b7f5aa5c&scoped=true&"
import script from "./preloader.vue?vue&type=script&lang=js&"
export * from "./preloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f5aa5c",
  null
  
)

export default component.exports